export const API_BASE_URL = "https://avtooyna.uz/restapi/";
export const API_IMG_URL = "https://avtooyna.uz/";
export const languages = ["uz", "ru", "en"];
export const fallbackLng = "uz";
